import { useFlags } from "flagsmith/react";
import type { IFlagsmithFeature } from "flagsmith/types";
import { Navigate, Outlet } from "react-router-dom";

/**
 * Flag gate on the close tracker routes — `/workflow`,
 * `/workflow/client/:companyId`, and the `/firm` redirect that feeds them.
 *
 * `hide_dashboard` is the flag the sidebar entry pointing at `/workflow`
 * already uses (`AppMenu.tsx`), so the page and the only link to it now turn
 * off together. Before this, the link could be flagged away while the URL
 * stayed live for anyone with a bookmark or a firm-digest email.
 *
 * The gate is INVERSE: the flag being ON hides the page. A flag Flagsmith
 * never returns reads as `undefined`, which falls through to rendering — a
 * missing or misspelled flag must not dark the close for every firm.
 *
 * Off-state is a redirect to `/` rather than a 404 so the
 * `/firm?company=N&period=YYYY-MM` links already sitting in inboxes land
 * somewhere useful. `workflow/:tab` (project management) is deliberately NOT
 * nested under this gate: it is a different product with its own
 * `disable_workflows` flag.
 */
export function CloseTrackerGate() {
	const flags = useFlags(["hide_dashboard"]);
	const isHidden = !!(flags.hide_dashboard as IFlagsmithFeature)?.enabled;

	if (isHidden) {
		return <Navigate to="/" replace />;
	}

	return <Outlet />;
}
